// A simple enum containing all necessary data for each attendance type
import {productAirport, productDelivery, productDriveThru, productSelfService, productStore} from "../../assets";

const ATTENDANCE_PICKER_DATA_ENUM = {
    unity: {
        id:        1,
        name:      "Nossas Unidades",
        uppercase: false,
        icon:      productStore
    },
    airport: {
        id:        2,
        name:      "Unidade Aeroporto",
        uppercase: false,
        icon:      productAirport
    },
    drivethru: {
        id:        3,
        name:      "Atendimento Drive-thru",
        uppercase: false,
        icon:      productDriveThru
    },
    unidade_drive: {
        id:        4,
        name:      "Unidade 24h",
        uppercase: false,
        icon:      productStore
    },
    self_service: {
        id:        5,
        name:      "Unidade Digital",
        uppercase: false,
        icon:      productSelfService
    },
    home_delivery: {
        id:        6,
        name:      "#VemSabin Atendimento Móvel",
        uppercase: false,
        icon:      productDelivery
    },
}

export default ATTENDANCE_PICKER_DATA_ENUM;
